import axiosInstance from 'pages/Utility/axiosInstance';
import React, { useEffect, useState } from 'react'
import { Modal, Switch } from 'antd';
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Button, FormGroup, Label, Checkbox, FormText } from "reactstrap";
import { showError } from 'helpers/notification_helper';

const MarkAsComplete = ({ id, handleClose, visible, setIsOpen, setConfirmation, setChecklistModal }) => {
    const [checklist, setChecklist] = useState();
    const [groupedData, setGroupedData] = useState({});
    const [initialValues, setInitialValues] = useState();
    const [validationSchema, setValidationSchema] = useState();
    const [resData, setResData] = useState();
    const [loading, setLoading] = useState();

    const fetchChecklists = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: "getWorkOrderChecklists", workOrderId: id } })
            if (response?.data) {
                setChecklist(response?.data?.Data);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (loading) return;
        fetchChecklists();
    }, [])

    useEffect(() => {
        if (checklist) {
            setGroupedData(checklist?.reduce((acc, item) => {
                if (!acc[item.catalogueId]) acc[item.catalogueId] = [];
                acc[item.catalogueId].push(item);
                return acc;
            }, {}))
        }
    }, [checklist]);

    // Initial values for Formik
    useEffect(() => {
        if (groupedData) {
            setInitialValues(Object?.keys(groupedData)?.reduce((acc, categoryId) => {
                const items = groupedData[categoryId];
                items.forEach(item => {
                    acc[item.checklistItem] = false;
                });
                return acc;
            }, {}))
            setValidationSchema(Yup.object(
                Object.keys(groupedData).reduce((acc, categoryId) => {
                    const items = groupedData[categoryId];
                    items.forEach(item => {
                        if (item.isMandatory) {
                            acc[item.checklistItem] = Yup.boolean();
                        }
                    });
                    return acc;
                }, {})))
        }
    }, [groupedData])

    const submitform = async (values) => {
        try {
            if (checklist?.length > 0) {
                const response = await axiosInstance.post('', {
                    sp: "usp_InsertWorkOrderChecklistResponse",
                    workOrderId: id,
                    responseData: JSON?.stringify(values)
                })
                if (response) {
                    setIsOpen(false)
                    setChecklistModal(true)
                    setConfirmation(false)
                    handleClose();
                }
            } else {
                setIsOpen(false)
                setChecklistModal(true)
                setConfirmation(false)
                handleClose();
            }

        } catch (error) {
            setConfirmation(false)
        }
    }

    const handleSubmit = (values) => {
        const mandatoryUnchecked = Object.keys(groupedData).reduce((acc, categoryId) => {
            const items = groupedData[categoryId];
            items.forEach(item => {
                if (item.isMandatory && !values[item.checklistItem]) {
                    acc.push(item.checklistItem);
                }
            });
            return acc;
        }, []);

        // If there are mandatory checkboxes not checked, show the common error
        if (mandatoryUnchecked.length > 0) {
            showError("Please check all mandatory fields.");
            return;
        } else {
            submitform(values);
            setResData(values);
        }
    };


    return (
        <Modal
            title={
                <div style={{ marginLeft: "33px", fontWeight: "bold" }}>
                    Check Lists
                </div>
            }
            visible={visible}
            onCancel={handleClose}
            footer={null}
            destroyOnClose
            centered
            width={500} // Reduced width of modal
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <style>
                {`
                .custom-modal-header .ant-modal-close {
                    margin-top: 3px; 
                    }
                `}
            </style>
            <div style={{ minheight: "200px" }}>
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, setFieldValue }) => (
                            <Form className="px-2 pt-2 pb-0 rounded mx-3 bg-white" style={{ minWidth: "300px", width: "600px", maxWidth: "500px", maxHeight: "400px" }}> {/* overflowY: "auto" */}

                                {/* Render each category group */}
                                {Object.keys(groupedData).map((categoryId) => {
                                    const items = groupedData[categoryId];
                                    return (
                                        <div key={categoryId} className='mb-3'>
                                            <h5 className='mb-3' style={{ color: "#5b626b", fontWeight: "100" }}>Category {categoryId}</h5>
                                            <div className="row">
                                                {items.map((item) => (
                                                    <div key={item.checklistItem} className="col-md-6">

                                                        <FormGroup key={item.checklistItem} >

                                                            <label className=" mb-0" style={{
                                                                color: "#000"
                                                            }}>
                                                                <Field
                                                                    type="checkbox"
                                                                    name={item.checklistItem}
                                                                    id={item.checklistItem}
                                                                    checked={values[item.checklistItem]}
                                                                    onChange={() => setFieldValue(item.checklistItem, !values[item.checklistItem])}
                                                                    className="form-check-input"
                                                                    style={{
                                                                        width: '17px',
                                                                        height: '17px',
                                                                        border: '1px solid #525f80',
                                                                        borderRadius: '2px',
                                                                        marginRight: '7px'
                                                                    }}
                                                                />
                                                                {item.checklistItem}
                                                            </label>{item.isMandatory && <span className="text-danger">*</span>}
                                                        </FormGroup>

                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Submit Button */}
                                <div className="text-center pt-3 border-top">
                                    {checklist?.length <= 0 && <h6 className='text-center'>No checklists found</h6>}

                                    {/* Custom Close Button */}
                                    {/* <Button
                                        color="secondary"
                                        onClick={handleClose}
                                        style={{
                                            marginRight : "10px",
                                        }}
                                    >
                                        Close
                                    </Button> */}
                                    <button type="button" className="btn btn-md btn-light" onClick={handleClose}>
                                        Close
                                    </button>
                                    <Button color="primary" type="submit" className='ms-3'>
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    )
}

export default MarkAsComplete;